import { _ as s } from "./index660.mjs";
import { i as r } from "./index597.mjs";
var a = s, t = r, i = "[object Arguments]";
function b(e) {
  return t(e) && a(e) == i;
}
var o = b;
export {
  o as _
};
